import { render, staticRenderFns } from "./clipboardPhotoUploader.vue?vue&type=template&id=5e329208&scoped=true&"
import script from "./clipboardPhotoUploader.vue?vue&type=script&lang=js&"
export * from "./clipboardPhotoUploader.vue?vue&type=script&lang=js&"
import style0 from "./clipboardPhotoUploader.vue?vue&type=style&index=0&id=5e329208&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e329208",
  null
  
)

export default component.exports